<template>
  <div class="workspace" v-if="onboardingForm">
    <div class="section-heading">
      <h2>Onboarding Form</h2>
<!--      <a href="#"><div class="tr-button green-button" @click="printReceipt"><i class="fas fa-print"></i> Print This Order</div></a>-->
    </div>

    <div class="order-detail-top">
      <h2>Form #: {{ onboardingForm.id }}</h2>
      <div class="order-detail-section">
        <div class="order-detail">
          <h3>Business Structure</h3>
          <h4 v-if="selectBusinessStructureOptions">{{`${selectBusinessStructureOptions.text}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Type of Business</h3>
          <h4 v-if="selectTypeOfBusiness">{{`${selectTypeOfBusiness.text}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Legal Business Name</h3>
          <h4>{{`${onboardingForm.legal_business_name}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Employer Identification Number (EIN)</h3>
          <h4>{{`${onboardingForm.identification_number}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Doing Business As</h3>
          <h4>{{`${onboardingForm.doing_business_as}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Business Website</h3>
          <h4>{{`${onboardingForm.business_website}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Legal Full Name</h3>
          <h4>{{`${onboardingForm.legal_name} ${onboardingForm.legal_last_name}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Email Address</h3>
          <h4>{{`${onboardingForm.email_address}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Date of Birth</h3>
          <h4>{{`${onboardingForm.birthday}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Address</h3>
          <h4>{{onboardingForm.street_address}} {{onboardingForm.city}} {{onboardingForm.state}} {{onboardingForm.zip_code}}</h4>
        </div>
        <div class="order-detail">
          <h3>Phone Number</h3>
          <h4>{{`${onboardingForm.phone}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Last 4 Digits of Social Security Number</h3>
          <h4>{{`${onboardingForm.social_security_number}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Bank Routing Number</h3>
          <h4>{{`${onboardingForm.bank_routing_number}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Bank Account Number</h3>
          <h4>{{`${onboardingForm.bank_account_number}` }}</h4>
        </div>
      </div>
    </div>
<!--    <print-pdf-template v-if="print" :order="order" :filename="`Catering_Order_${order.id}`"/>-->
  </div>
</template>

<script>
//import printPdfTemplate from './printPdfTemplate'

import {mapActions} from 'vuex'

export default {
  components: {
    // printPdfTemplate
    // SendRestaurantSidebar
  },
  props: {
    formId: String
  },
  data () {
    return {
      isMounted: false,
      order: null,
      onboardingForm: {},
      selectTypeOfBusiness: null,
      selectBusinessStructureOptions: null,
      typeOfBusinessOptions: [
        {
          text: 'Individual',
          value: 'individual'
        },
        {
          text: 'Company',
          value: 'company'
        },
        {
          text: 'Nonprofit Organization',
          value: 'nonprofit-organization'
        }
      ],
      businessStructureOptions: [
        {
          value: 'sole-proprietorship',
          text: 'Sole Proprietorship'
        },
        {
          value: 'single-member-llc',
          text: 'Single Member LLC'
        },
        {
          value: 'multi-member-llc',
          text: 'Multi Member LLC'
        },
        {
          value: 'private-partnership',
          text: 'Private Partnership'
        },
        {
          value: 'private-corporation',
          text: 'Private Corporation'
        },
        {
          value: 'other',
          text: 'Other/I\'m not sure'
        }
      ]
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    ...mapActions('onBoarding', ['getOnboarding']),
    async getOnboardingData () {
      this.$vs.loading()
      const onboarding = await this.getOnboarding({payload: {formId: this.formId}})
      if (onboarding.status) {
        this.onboardingForm = onboarding.data
        this.findSelectTypeOfBusinessOption()
        this.findSelectBusinessStructureOptions()
      } else {
        this.openNotify({title: 'Error', icon: 'icon-alert-circle', text: onboarding.message, color: 'danger' })
      }
      this.$vs.loading.close()
    },
    findSelectTypeOfBusinessOption () {
      this.selectTypeOfBusiness = this.typeOfBusinessOptions.find(option => option.value === this.onboardingForm.type_of_business)
    },
    findSelectBusinessStructureOptions () {
      this.selectBusinessStructureOptions = this.businessStructureOptions.find(option => option.value === this.onboardingForm.business_structure)
    }
  },
  created () {
  },
  mounted () {
    this.isMounted = true
    this.getOnboardingData()
  }
}
</script>

<style lang="scss">
.con-exemple-prompt {
  .vs-component {
    width: 100%;
    .vs-input--placeholder.normal {
      padding: 5px 10px !important;
    }
  }
}
</style>
